import React from "react";
import { Checkbox } from 'antd';


const FamilyItem = ({
  id, name, status, className, onToggleFamilyStatus,
}) => {
  const onToggleStatus = (e) => onToggleFamilyStatus(id, e.target.checked);
  return (
    <div className={`familyItem ${className}`}>
      { name }
      <span className='checkBox'>
        <Checkbox
          onChange={onToggleStatus}
          checked={status}
        >
        </Checkbox>
      </span>
    </div>
  )
}
export default FamilyItem;
